/**
 * @desc 站点店铺-修改
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.PlatformSiteShopRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSiteShop/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
